import { useState } from "react";
import { getOnlyFranchisePub } from "../../../../api/cafe";

export enum WalletTab {
  WALLET = "WALLET",
  HISTORY = "HISTORY",
  LOGS = "LOGS",
  ORDER = "ORDER",
}

export enum WalletLogTab {
  POINT = "POINT",
  SEED = "SEED",
  MILEAGE = "MILEAGE",
  SUBPRIZE = "SUBPRIZE",
}

export const useWalletTab = () => {
  const [walletTab, setWalletTab] = useState(WalletTab.WALLET);
  const [logTab, setLogTab] = useState(WalletLogTab.POINT);

  const [isFranchisePubOpen, setIsFranchisePubOpen] = useState(false);

  const isWalletTab = (tab: WalletTab) => walletTab === tab;
  const isLogTab = (tab: WalletLogTab) => logTab === tab;

  const getFranchisePub = async () => {
    const res = await getOnlyFranchisePub();
    return res;
  };

  return {
    walletTab,
    setWalletTab,
    isWalletTab,
    logTab,
    setLogTab,
    isLogTab,
    getFranchisePub,
    isFranchisePubOpen,
    setIsFranchisePubOpen,
  };
};
